import React, { useState, useEffect } from 'react';
import { Button, Card, Autocomplete, TextField, Box, Typography } from '@mui/material';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { BASE_URL } from '../../App';
import Grid from '@mui/material/Grid';
import Swal from 'sweetalert2';

const DefectivePendingReport = () => {
  const [branch, setBranch] = useState('');
  const [psg, setPsg] = useState('ALL');
  const [branchData, setBranchData] = useState([]);
  const [psgData, setPsgData] = useState([]);
  const [ReportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isDataFetched, setIsDataFetched] = useState(false);
  const loginId = localStorage.getItem("LOGIN_ID");
const branchCode = localStorage.getItem("BRANCH_CODE");
const groupCode =localStorage.getItem("GROUP_CODE");
  

  useEffect(() => {
    const fetchBranchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/getbranchname', {
          BRANCH_CODE: branchCode,
          login_id: loginId,
          GROUP_CODE: groupCode
        });
        setBranchData(response.data.branchList);
      } catch (error) {
        console.error('Error fetching branch data:', error);
      }
    };
    fetchBranchData();
  }, []);

  useEffect(() => {
    const fetchPsgOptions = async () => {
      setLoading(true);
      try {
        const response = await axios.post(BASE_URL + '/getpsgoptions');
        if (response.data?.psglist) {
          setPsgData([...response.data.psglist]);
        } else {
          setError('No PSG options available.');
        }
      } catch (err) {
        console.error('Error fetching PSG data:', err);
        setError('Error fetching PSG data.');
      } finally {
        setLoading(false);
      }
    };

    fetchPsgOptions();
  }, []);

  const fetchDefectiveReports = async () => {
    if (!branch) {
      setError('Please select a branch');
      return;
    }

    setLoading(true);
    try {
      const branchValue = branch === 'ALL' ? 'ALL' : branch;
      const psgValue = psg === 'ALL' ? '' : psg.MATSUBGROUP_CODE;

      const response = await axios.post(BASE_URL + '/getdefectivereports', {
        branch: branchValue,
        psg: psgValue
      });

      console.log('Defective reports response:', response);

      if (response.data?.reportList) {
        setReportData(response.data.reportList); 
        setIsDataFetched(true);
      } else {
        setReportData([]);
        setError('No data available to download.');
        setIsDataFetched(false);
      }
    } catch (error) {
      console.error("Error fetching defect report data:", error);
      setError('Error fetching report data.');
      setReportData([]);
      setIsDataFetched(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isDataFetched && ReportData.length > 0) {
      showDownloadConfirmation();
    }
  }, [isDataFetched, ReportData]);

  const showDownloadConfirmation = () => {
    Swal.fire({
      title: 'Download Report?',
      text: 'Do you want to download the report?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Download',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        downloadReport(); 
      } else {
        Swal.close(); 
      }
    });
  };

  const downloadReport = () => {
    if (Array.isArray(ReportData) && ReportData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(ReportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');

      XLSX.writeFile(wb, `report_${branch}_${psg}.xlsx`);

      Swal.fire({
        title: 'Download Complete',
        text: 'The report has been successfully downloaded.',
        icon: 'success',
        confirmButtonText: 'OK'
      });
    } else {
      Swal.fire({
        title: 'No Data',
        text: 'There is no data to download.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Grid container justifyContent="flex-start" sx={{ marginBottom: 3 }}>
        <Grid item xs={12} md={6}>
          <Card sx={{ padding: 3 }}>
            <Grid container justifyContent="flex-start" spacing={3} sx={{ marginBottom: 3 }}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="branch-autocomplete"
                  value={branch}
                  onChange={(e, newValue) => setBranch(newValue)}
                  options={['ALL', ...branchData.map(item => item.BRANCH_CODE)]}
                  getOptionLabel={(option) =>
                    option === 'ALL' ? 'All' : branchData.find(item => item.BRANCH_CODE === option)?.BRANCH_NAME || ''
                  }
                  renderInput={(params) => <TextField {...params} label="Select Branch" />}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="psg-autocomplete"
                  value={psg}
                  onChange={(e, newValue) => setPsg(newValue)}
                  options={psgData}
                  getOptionLabel={(option) =>
                    option === 'ALL' ? 'All' : option.DESCRIPTION || ''
                  }
                  renderInput={(params) => <TextField {...params} label="Select PSG" />}
                  fullWidth
                />
              </Grid>
            </Grid>

            {error && (
              <Typography color="error" variant="body2" sx={{ textAlign: 'center', marginBottom: 2 }}>
                {error}
              </Typography>
            )}

            <Grid container justifyContent="center">
              <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={fetchDefectiveReports}
                  disabled={loading}
                  sx={{ width: '100%' }}
                >
                  {loading ? 'Downloading...' : 'Download as Excel'}
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DefectivePendingReport;













